import { render } from "./TabPlantDetailsPlotSavings.vue?vue&type=template&id=b9cc2d40"
import script from "./TabPlantDetailsPlotSavings.vue?vue&type=script&lang=js"
export * from "./TabPlantDetailsPlotSavings.vue?vue&type=script&lang=js"

import "./TabPlantDetailsPlotSavings.vue?vue&type=style&index=0&id=b9cc2d40&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__